import { useContext, useEffect } from "react";
import SidebarContext from "./SidebarContext";

/**
 * Hook to register a validator for a specific page
 * The validator function receives (emittedData, runtimeData) and should return true if valid
 *
 * @param {string} pageName - The name of the page this validator is for
 * @param {Function} validatorFn - Function that returns true if the page is valid
 *
 * Usage:
 * usePageValidator('basic_details', (emittedData, runtimeData) => {
 *   return emittedData.name?.trim().length > 0;
 * });
 */
const usePageValidator = (pageName, validatorFn) => {
    const { registerPageValidator, unregisterPageValidator } =
        useContext(SidebarContext);

    useEffect(() => {
        if (pageName && validatorFn) {
            registerPageValidator(pageName, validatorFn);
            return () => {
                unregisterPageValidator(pageName);
            };
        }
    }, [pageName, validatorFn, registerPageValidator, unregisterPageValidator]);
};

export default usePageValidator;
